import React from "react";

const Skill = ({ skill }) => (
  <div key={skill.skillName} className="bg-primary p-2 text-center font-weight-bold rounded">
    {skill.skillName}
  </div>
);

export default Skill;
